// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__j4ZRe","boxTitle":"Qualiphy_boxTitle__PCY5j","box":"Qualiphy_box__2HwFG","toggleWrap":"Qualiphy_toggleWrap__iJ0C2"};